//--------------- IMPORTAÇÕES ---------------//
import { useContext, useEffect } from "react";
import { OrderbumpsContext } from "../context/OrderbumpsContext";
import { loadReportsService } from "../services";



//--------------- EXPORTAÇÃO DA PÁGINA ORDERBUMP RELATÓRIO ---------------//
export default function ContainerFilters() {



    //--------------- CRIAÇÃO DE HOOKS ---------------//
    const { products, setProducts } = useContext(OrderbumpsContext); // Estado que armazena a lista de produtos existentes
    const { idProduct, setIdProduct } = useContext(OrderbumpsContext); // Estado que armazena o ID do produto selecionado pelo usuário
    const { startDateFilter, setStartDateFilter } = useContext(OrderbumpsContext); // Estado que armazena a data inicial selecionada pelo usuário como filtro de pesquisa
    const { endDateFilter, setEndDateFilter } = useContext(OrderbumpsContext); // Estado que armazena a data final selecionada pelo usuário como filtro de pesquisa
    const { data, setData } = useContext(OrderbumpsContext); // Estado que armazena os Dados da busca feita pelo usuário
    const { transactions, setTransactions } = useContext(OrderbumpsContext); // Estado que armazena a lista de transações existentes
    const { orderbumps, setOrderbumps } = useContext(OrderbumpsContext);



    //--------------- FUNÇÃO ASSÍNCRONA BUSCAR DADOS ---------------//
    // Responsável por requisitar à API os Dados existentes do grupo informado pelo usuário
    // Armazena no Estado "dados" o retorno da API
    async function handleLoadData() {
        const response = await loadReportsService(idProduct, startDateFilter, endDateFilter)
        if (response) {
            console.log(response.data)
            setData(response.data);
            if (response.data?.transacoes) {
                console.log(response.data.transacoes)
                setTransactions(response.data.transacoes);
            }
            if (response.data?.orderbumps){
                console.log(response.data.orderbumps)
                setOrderbumps(response.data.orderbumps);
            }
        }
    };



    //--------------- RETORNO CONDICIONAL DA PÁGINA ORDERBUMP RELATÓRIO ---------------//
    return (
        <>

            {/* DIV DOS FILTROS DE PESQUISA */}
            <div className="flex flex-col sm:flex-row w-full gap-4 mb-6">

                <div className="flex flex-col w-full sm:max-w-[250px]">
                    <label className="text-sm text-ink-3 mb-1">Filtrar por Grupo de Produtos</label>
                    {/* SELECT DO GRUPO */}
                    <select value={idProduct} onChange={e => setIdProduct(e.target.value)} className="h-[40px] bg-surface-2 p-2 rounded w-full">
                        <option value="">Selecione o grupo</option>
                        {products.map(p => (
                            <option key={p.id} value={p.id}>{p.nome}</option>
                        ))}
                    </select>
                </div>

                <div className="flex flex-col w-full sm:max-w-[250px]">
                    <label className=" text-sm text-ink-3 mb-1">Filtrar Data Inicial</label>
                    {/* INPUT DA DATA INICIAL */}
                    <input type="date" value={startDateFilter} onChange={e => setStartDateFilter(e.target.value)} className="h-[40px] bg-surface-2 p-2 rounded w-full" />
                </div>

                <div className="flex flex-col w-full sm:max-w-[250px]">
                    <label className="text-sm text-ink-3 mb-1">Filtrar Data Final</label>
                    {/* INPUT DA DATA FINAL */}
                    <input type="date" value={endDateFilter} onChange={e => setEndDateFilter(e.target.value)} className="h-[40px] bg-surface-2 p-2 rounded w-full" />
                </div>

                <div className="flex flex-col w-full sm:max-w-[250px]">
                    <label className="text-sm text-ink-3 mb-1">&nbsp;</label>
                    {/* BUTTON BUSCAR */}
                    <button onClick={handleLoadData} className="h-[40px] bg-brand-600 hover:bg-brand-700 p-2 rounded w-full">Buscar</button>
                </div>
            </div>

        </>
    );
}
